import { Preferences } from 'commons/constants/KeyFlowConstants';
import AssetParamVO from 'commons/vo/param/AssetParamVO';
import { url } from 'inspector';
import { useCallback, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  requestCategoryList,
  requestCodeList,
  requestConfigList,
  requestPreferenceList,
  requestStorageList,
} from 'redux/actions/actions';
import { RootState } from 'redux/reducers/type';

export default function useInit() {
  const { isInit: isInitStorage, isLoading: isLoadingStorage } = useSelector(
    (state: RootState) => state.storage,
  );
  const { isInit: isInitCategory, isLoading: isLoadingCategory } = useSelector(
    (state: RootState) => state.category,
  );

  const { isInit: isInitCode, isLoading: isLoadingCode } = useSelector(
    (state: RootState) => state.code,
  );

  const { isInit: isInitPreference, isLoading: isLoadingPreference } = useSelector(
    (state: RootState) => state.preference,
  );

  const { isInit: isInitConfig, isLoading: isLoadingConfig } = useSelector(
    (state: RootState) => state.config,
  );

  const dispatch = useDispatch();

  const isInit = useMemo(() => {
    return isInitStorage && isInitCategory && isInitCode && isInitPreference && isInitConfig;
  }, [isInitStorage, isInitCategory, isInitCode, isInitPreference, isInitConfig]);

  const onInitStorage = useCallback(() => {
    dispatch(requestStorageList());
  }, [dispatch]);

  const onInitCategory = useCallback(() => {
    dispatch(requestCategoryList());
  }, [dispatch]);

  const onInitCode = useCallback(() => {
    dispatch(requestCodeList());
  }, [dispatch]);

  const onInitPreference = useCallback(() => {
    dispatch(
      requestPreferenceList({
        groupNames: [Preferences.groupNames.VIDEO, Preferences.groupNames.VIDEO_LIBRARY],
      }),
    );
  }, [dispatch]);

  const onInitConfig = useCallback(() => {
    dispatch(requestConfigList());
  }, []);

  const onInit = useCallback(() => {
    onInitStorage();
    onInitCategory();
    onInitCode();
    onInitPreference();
    onInitConfig();
    console.log('onInit()');
  }, [onInitStorage, onInitCategory, onInitCode, onInitPreference, onInitConfig]);

  return useMemo(
    () => ({
      isInit,
      onInit,
    }),
    [isInit, onInit],
  );
}
